module.exports = __webpack_public_path__ + "img/ae.38a1accd.svg";